import { Vehicle } from "@commons/models/domain/Vehicle";
import { VehicleTachoSlot } from "@commons/models/domain/VehicleTacho";
import { LatLng } from "leaflet";

export function getVehicleCoords(data: Vehicle): LatLng {
    if (data.LL) {
        const _lat = parseFloat(data.LL.Lt + '');
        const _lng = parseFloat(data.LL.Ln + '');

        if (_lat && _lat !== 361 && _lng && _lng !== 361) {
            const lat = (_lat);
            const lng = (_lng);
            const coords = new LatLng(lat, lng);
            return coords;
        }
    }
    return null as any;
}

export function getActiveTachoSlot(vehicle: Vehicle): VehicleTachoSlot {
    if (vehicle.Tacho) {
        const ifSlot1 = vehicle.Tacho.S1 && vehicle.Tacho.S1.Id;
        if (ifSlot1) {
            return vehicle.Tacho.S1 as VehicleTachoSlot;
        }
        const ifSlot2 = vehicle.Tacho.S2 && vehicle.Tacho.S2.Id;
        if (ifSlot2) {
          return vehicle.Tacho.S2 as VehicleTachoSlot;
        }
    }
    return null as any;
}

export function calculateVehicleTimeInCurrentState(data: Vehicle): number {
    const controls = data.ControlIndicators;
    let value = (controls || []).filter(o => o && o.Group === 13);
    let cValue = (value && value.length > 0 && value[0].LV) ? value[0].LV : null;

    const today = new Date();
    const theDay = new Date(cValue.T);
    const diffMs = (today.getTime() - theDay.getTime());
    const diffMins = Math.ceil(diffMs / 1000);
    return diffMins;
}